export default "__VITE_PUBLIC_ASSET__65910936__"